import { useLazyQuery, useQuery } from "@apollo/client"
import { FC, useEffect, useRef, useState } from "react"
import { IGetPatientPhotoInput, IGetPatientPhotoOutput, IGetProviderPatientByIdInput, IGetProviderPatientByIdOutput, IGetProviderPatientChartAlertInput, IGetProviderPatientChartAlertOutput } from "../../graphql/types/queries/patient"
import { GET_PATIENT_BY_ID, GET_PATIENT_CHART_ALERTS, GET_PATIENT_PHOTO } from "../../graphql/queries"
import styled from "styled-components"
import { Box, Flex, Heading, Image, Text } from "rebass/styled-components"
import { Constants } from "../../utils/Constants"
import { sleep } from "../../utils/sleep"
import ReactTooltip from "react-tooltip"
import { getMockedFirstName, getMockedLastName } from "../../utils/mocks"
import HpiMenu from "./HpiMenu"
import Select from "react-select";
import { ReactSelectStyles } from "../../styles/ReactSelectStyles";
import { CloseButton } from "./components/TabulatorHpi"
import Modal from "styled-react-modal"
import SendSms from "../../components/SendSms"
import { ViewHpi } from "./components/hpi/ViewHpi"
import { Skeleton } from "../../components/loadingSkeleton/Skeleton"
import { SpecialModalBackground } from "../../components/Commons"
import { PatientsPhoto } from "./components/PatientsPhoto"
import moment from "moment"

export const AiIcon = () => {
  return (<svg width="16" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 8.99998L11 7.49998L15 5.99848L16.5 2L18.0014 5.99848L22 7.49998L18.0014 8.99998L16.5 13L15 8.99998ZM6.99997 17L2 15L6.99997 13L8.99998 8L11 13L16 15L11 17L8.99998 22L6.99997 17Z" fill="#344F7A" />
  </svg>
  )
}

const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 0;
  max-width: 100%;
  max-height: 100%;
  height: 100%;
  overflow: hidden;
  flex: 1;
`
interface IProps {
  patientId: string
  onClose: () => void
}


const HpisWrapper: FC<IProps> = ({ patientId, onClose }) => {
  const [isSendSms, setisSendSms] = useState<boolean>(false);
  const chartAlertRef = useRef<any>(null)
  const [selectedHpiTarget, setSelectedHpiTarget] = useState<'hypo' | 'meno' | 'weightlossInitial' | 'weightlossReturning' | undefined>()
  const [isSelectDisabled, setIsSelectDisabled] = useState(false)
  const { data: dataPatient, loading: loadingPatient, error: errorPatient } = useQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID, {
    variables: {
      id: patientId
    }
  })
  const { data, loading, error, refetch: refetchChartAlerts } = useQuery<IGetProviderPatientChartAlertOutput, IGetProviderPatientChartAlertInput>(GET_PATIENT_CHART_ALERTS, {
    variables: {
      id: patientId
    },
    onCompleted: async () => {
      await sleep(300)
      ReactTooltip.rebuild()

      ReactTooltip.show(chartAlertRef.current)
    }
  })
  if (loadingPatient || !dataPatient) return null

  let patientName = `${dataPatient?.getProviderPatientById?.firstname} ${dataPatient?.getProviderPatientById?.lastname}`
  if (Constants.IS_SCRAMBLING_MODE) {
    patientName = `${getMockedFirstName()} ${getMockedLastName()}`
  }
  return (
    <Container id='aall2' flexDirection={'column'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }}>
      <Flex mb={[2, 4, 4]} flexDirection={['column', 'row', 'row']}>
        {/* <Box display={['none!important', 'flex !important', 'flex !important']}>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
          </svg>
        </Box> */}
        <PatientsPhoto loading={loadingPatient} data={dataPatient} />
        <Flex flexDirection={'row'} mb={[3, 0, 0]} alignItems={'center'} flex={1} justifyContent={'center'}>
          <Flex flexDirection={'column'} justifyContent={'center'}>
            <Flex alignItems={'center'}>
              <Heading mr={3}>{`${patientName}, ID ${dataPatient?.getProviderPatientById?.athenaId}`}
              </Heading>
              {!!dataPatient?.getProviderPatientById?.preferredPronouns && (
                <Text fontWeight={300} fontSize='12px' mr={3}>{`${dataPatient?.getProviderPatientById.preferredPronouns}`}</Text>
              )}
              <Box style={{ border: `1px solid #344f79`, borderRadius: '8px', padding: '0 4px', background: 'rgb(121,146, 179)' }} mr={3}>
                <Text fontWeight={400} fontSize='12px' color='white'>{`${dataPatient?.getProviderPatientById?.state}`}</Text>
              </Box>
              {data && data.getProviderPatientChartAlert && (
                <Flex
                  ref={chartAlertRef}
                  data-event="click"
                  justifyContent={'center'}
                  alignItems='center'
                  padding={'0px'}
                  alignSelf='center'
                  mr={3}
                  data-tip
                  data-for='chartAlertTooltip'
                  // onClick={()=>ReactTooltip.(chartAlertRef.current)}
                  style={{ backgroundColor: "#fccc00", borderBottomLeftRadius: '10px' }}>
                  <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.00195 11.0001C7.00195 10.8688 7.02782 10.7388 7.07807 10.6174C7.12833 10.4961 7.20199 10.3859 7.29485 10.293C7.38771 10.2002 7.49794 10.1265 7.61927 10.0762C7.7406 10.026 7.87063 10.0001 8.00195 10.0001C8.13328 10.0001 8.26331 10.026 8.38464 10.0762C8.50596 10.1265 8.6162 10.2002 8.70906 10.293C8.80192 10.3859 8.87558 10.4961 8.92583 10.6174C8.97609 10.7388 9.00195 10.8688 9.00195 11.0001C9.00195 11.2653 8.8966 11.5197 8.70906 11.7072C8.52152 11.8948 8.26717 12.0001 8.00195 12.0001C7.73674 12.0001 7.48238 11.8948 7.29485 11.7072C7.10731 11.5197 7.00195 11.2653 7.00195 11.0001V11.0001ZM7.09995 4.99512C7.08664 4.86896 7.09999 4.74141 7.13915 4.62075C7.17831 4.50008 7.24241 4.389 7.32727 4.2947C7.41214 4.20041 7.51588 4.12501 7.63176 4.0734C7.74765 4.02179 7.87309 3.99512 7.99995 3.99512C8.12681 3.99512 8.25226 4.02179 8.36814 4.0734C8.48403 4.12501 8.58777 4.20041 8.67263 4.2947C8.7575 4.389 8.82159 4.50008 8.86075 4.62075C8.89991 4.74141 8.91327 4.86896 8.89995 4.99512L8.54995 8.50212C8.53573 8.63808 8.47166 8.76396 8.37009 8.85546C8.26852 8.94696 8.13666 8.99759 7.99995 8.99759C7.86325 8.99759 7.73139 8.94696 7.62982 8.85546C7.52825 8.76396 7.46417 8.63808 7.44995 8.50212L7.09995 4.99512Z" fill="black" />
                  </svg>

                </Flex>
              )}
            </Flex>
            <Flex style={{ gap: '12px' }}>

              <Text style={{ fontSize: '13px', fontWeight: 300 }}>{moment().diff(moment(dataPatient?.getProviderPatientById?.dob, 'MM/DD/YYYY'), 'y')} yo</Text>
              {!!dataPatient.getProviderPatientById && (
                <>
                  {dataPatient.getProviderPatientById?.medicalHistory?.hasDiabetes && <Text style={{ fontSize: '13px', fontWeight: 300, color: '#d27373', paddingRight: '12px', borderRight: '1px solid #bebed9' }}>has diabeted</Text>}
                  {dataPatient.getProviderPatientById?.medicalHistory?.hasHashi && <Text style={{ fontSize: '13px', fontWeight: 300, color: '#d27373', paddingRight: '12px', borderRight: '1px solid #bebed9' }}>has hashimoto</Text>}
                  {dataPatient.getProviderPatientById?.medicalHistory?.hasHyper && <Text style={{ fontSize: '13px', fontWeight: 300, color: '#d27373', paddingRight: '12px', borderRight: '1px solid #bebed9' }}>has hyperthyroidism</Text>}
                  {dataPatient.getProviderPatientById?.medicalHistory?.hasHypo && <Text style={{ fontSize: '13px', fontWeight: 300, color: '#d27373', paddingRight: '12px', borderRight: '1px solid #bebed9' }}>has hypothyroidism</Text>}
                  {dataPatient.getProviderPatientById?.medicalHistory?.radiationTherapy && <Text style={{ fontSize: '13px', fontWeight: 300, color: '#d27373', paddingRight: '12px', borderRight: '1px solid #bebed9' }}>radiation therapy</Text>}
                  {dataPatient.getProviderPatientById?.medicalHistory?.thyroidRemoved && <Text style={{ fontSize: '13px', fontWeight: 300, color: '#d27373', paddingRight: '12px', borderRight: '1px solid #bebed9' }}>thyroid removed</Text>}
                </>
              )}
            </Flex>
          </Flex>
          <Box style={{ border: '1px solid #CDD9EC', cursor: 'pointer', padding: '4px 12px', borderRadius: '10px' }} ml={4} mr={'6px'} onClick={() => setisSendSms(true)}>
            <Text style={{ userSelect: 'none' }} fontSize={'11px'} textAlign={'center'}>Send SMS</Text>
          </Box>
          {!!selectedHpiTarget ? (
            <Flex flex={1} justifyContent={'flex-end'} alignItems={'center'} style={{ opacity: isSelectDisabled ? 0.5 : 1, paddingRight: '35px' }}>
              <Text mr={2}>HPI Target: </Text>
              <Select
                styles={ReactSelectStyles.initialStyles}
                isDisabled={isSelectDisabled}
                isSearchable={false}
                options={[
                  {
                    label: 'Hypothyroidism',
                    value: 'hypo',
                  },
                  {
                    label: 'Menopause',
                    value: 'meno',
                  },
                  {
                    label: 'Weightloss - Initial',
                    value: 'weightlossInitial',
                  },
                  {
                    label: 'Weightloss - Returning',
                    value: 'weightlossReturning',
                  }
                ]}
                value={[
                  {
                    label: 'Hypothyroidism',
                    value: 'hypo',
                  },
                  {
                    label: 'Menopause',
                    value: 'meno',
                  },
                  {
                    label: 'Weightloss - Initial',
                    value: 'weightlossInitial',
                  },
                  {
                    label: 'Weightloss - Returning',
                    value: 'weightlossReturning',
                  }
                ].find(x => x.value === selectedHpiTarget)}
                onChange={(option: any) => {
                  if (!option) return
                  setSelectedHpiTarget(option.value)
                }} />
            </Flex>) : <Flex flex={1} />
          }
          <CloseButton onClick={onClose} style={{ position: 'relative', top: 0, right: 0, justifySelf: 'flex-end' }} />
        </Flex>
      </Flex>
      <Flex flex={1} style={{ overflow: 'hidden' }} flexDirection={'row-reverse'}>
        <Flex flex={1}>
          <ViewHpi athenaId={patientId} selectedHpiTarget={selectedHpiTarget} setSelectedHpiTarget={setSelectedHpiTarget} onLoadingChange={setIsSelectDisabled} />
        </Flex>
        <Flex id='ttt' flexDirection={'column'} mr={[0, 4, 4]} style={{ background: 'white', minHeight: '100%', width: '136px', borderRadius: '12px 12px 0 0' }}>
          <HpiMenu id={patientId} helpscoutId={dataPatient.getProviderPatientById?.helpscoutId} />
        </Flex>
      </Flex>
      <Modal
        isOpen={!!isSendSms}
        onBackgroundClick={() => setisSendSms(false)}
        onEscapeKeydown={() => setisSendSms(false)}>
        <SendSms id={dataPatient.getProviderPatientById?.athenaId} name={`${dataPatient.getProviderPatientById?.firstname} ${dataPatient.getProviderPatientById?.lastname}`} close={() => { setisSendSms(false) }} />
      </Modal>
    </Container>
  )
}

export default HpisWrapper